window.validatorExt = function validatorExt(idForm) {
    jQuery.validator.addMethod("isMailOrTel", function (value, element) {
            
        var email   = $(idForm + " input[name=email]").val().trim();
                var tel = '';
                if($(idForm + " input[name=telefono]").length > 0){
                     tel = $(idForm + " input[name=telefono]").val();
                }
        var aConf   = [];
                
                
                if(tel != '' && tel != undefined && email != '' && email != undefined){
                    var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[a-zA-Z0-9](?:\.[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}))$/i;
                    if (email.match(regex)) {
                            aConf.push(1);
                    } else {
                            aConf.push(0);
                    }

                }else if (tel != '' && tel != undefined) {
            aConf.push(1);
                        
        } else if (email != '' && email != undefined) {
                    
                         var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:[a-zA-Z0-9](?:\.[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]{2,6}))$/i;
            if (email.match(regex)) {
                aConf.push(1);
            } else {
                aConf.push(3);
            }
                        
        }else {
            aConf.push(0);
        }

        if ($.inArray(1, aConf) != -1) {
            return true;
        } else {
            return false;
        }

    }, "Inserire una email o telefono.");

    jQuery.validator.addMethod("isNomeOCognome", function (value, element) {
        var nome = $(idForm + " #fc_nome").val();
        var cognome = $(idForm + " #fc_cognome").val();
        var aConf = [];

        if (nome != '' && nome != undefined)
        {
            aConf.push(1);
        } else {
            aConf.push(0);
        }

        if (cognome != '' && cognome != undefined) {
            aConf.push(1);
        } else {
            aConf.push(0);
        }

        if ($.inArray(1, aConf) != -1) {
            return true;
        } else {
            return false;
        }
    }, "Inserire un nome o cognome.");

    $.validator.addMethod('contieneLettereENumeri', function(value, element) {
        return this.optional(element) || (value.match(/[a-zA-Z]/) && value.match(/[0-9]/));
    }, aLang.validaLettereENumeri);
}

$('#form-consulenza-mutuo').validate({
    rules: {
        nome: {
            required:  true,
            maxlength: 255,
        },
        cognome: {
            required:  true,
            maxlength: 255,
        },
        email: {
            required: true,
            email: true,
            maxlength: 255,
        },
        messaggio: {
            required:  true,
            maxlength: 500,
        },
        privacy: {
            required: true,
        }
    },
    messages : oLang.validazioni.consulenzaMutuo
});

$('#form-consulenza-mutuo-modal').validate({
    rules: {
        nome: {
            required:  true,
            maxlength: 255,
        },
        cognome: {
            required:  true,
            maxlength: 255,
        },
        email: {
            required: true,
            email: true,
            maxlength: 255,
        },
        messaggio: {
            required:  true,
            maxlength: 500,
        },
        privacy: {
            required: true,
        }
    },
    messages : oLang.validazioni.consulenzaMutuo
});


$('#form-lavora-con-noi').validate({
    rules: {
        nome: {
            required: true,
            maxlength: 255,
        },
        cognome: {
            required: true,
            maxlength: 255,
        },
        email: {
            required: true,
            email: true,
            maxlength: 255,
        },
        email: {
            required: true,
            email: true,
            maxlength: 255,
        },
        telefono:{
            required: true,
            matches: "[0-9]+",
            minlength: 7,
            maxlength: 11
        },
        privacy: {
            required: true,
        },
        curriculum: {
            required: true,
            accept: "application/pdf",
            filesize: 100000
        }
    },
    messages: oLang.validazioni.consulenzaMutuo
});
